import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface StatusBadgeProps {
	isActive: boolean;
	className?: string;
	inactiveLabel?: string;
}

export function StatusBadge({
	isActive,
	className,
	inactiveLabel = 'Inactive'
}: StatusBadgeProps) {
	// Only show badge when inactive
	if (isActive) {
		return null;
	}

	return (
		<Badge
			variant="outline"
			className={cn(
				'text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5',
				'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800/60 dark:bg-amber-950/30 dark:text-amber-200',
				className
			)}
		>
			{inactiveLabel}
		</Badge>
	);
}
